var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atom-background',{staticClass:"atom-tag",attrs:{"tag":"small","color":"yellow","opacity":"0.32"}},[(_vm.text)?[_vm._v(_vm._s(_vm.text))]:_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }